/* ===============================
   GLOBAL HELPERS
================================= */
function renderPage(url) {
  return fetch(url, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  }).then(res => res.text());
}

function updateDOM(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');

  const newGrid = doc.querySelector('[data-product-grid]');
  const currentGrid = document.querySelector('[data-product-grid]');
  if (newGrid && currentGrid) {
    currentGrid.innerHTML = newGrid.innerHTML;
  }

  const newForms = doc.querySelectorAll('facets-form-component');
  const currentForms = document.querySelectorAll('facets-form-component');

  newForms.forEach((form, i) => {
    if (currentForms[i]) {
      currentForms[i].innerHTML = form.innerHTML;
    }
  });
}

/* ===============================
   RESULTS LIST
================================= */
class ResultsList extends HTMLElement {}
customElements.define('results-list', ResultsList);

/* ===============================
   FACET INPUTS  
================================= */
class FacetInputsComponent extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', () => {
      if (this.closest('filters-drawer')) return;

      const form = this.closest('form');
      const formData = new FormData(form);

      const url = new URL(window.location.href);

      //  clear all filters first
      [...url.searchParams.keys()].forEach(key => {
        if (key.startsWith('filter.')) {
          url.searchParams.delete(key);
        }
      });

      //  add selected filters
      formData.forEach((value, key) => {
        if (value !== '' && value !== null) {
          url.searchParams.append(key, value);
        }
      });

      renderPage(url.toString()).then(html => {
        updateDOM(html);
        window.history.pushState({}, '', url);
      });
    });
  }
}
customElements.define('facet-inputs-component', FacetInputsComponent);

/* ===============================
   REMOVE FILTER
================================= */
class FacetRemoveComponent extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      e.preventDefault();

      const url = this.dataset.url;
      if (!url) return;

      const drawer = this.closest('filters-drawer');

      renderPage(url).then(html => {
        updateDOM(html);
        window.history.pushState({}, '', url);

        if (drawer?.closeDrawer) {
          drawer.closeDrawer();
          document.body.classList.remove("overflow-hidden", "open-filter-drawer");
        }
      });
    });
  }
}
customElements.define('facet-remove-component', FacetRemoveComponent);

/* ===============================
   CLEAR FILTER
================================= */
class FacetClearComponent extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('.clear-filter');
      if (!btn) return;

      e.preventDefault();

      const drawer = this.closest('filters-drawer');
      const url = new URL(window.location.href);

      [...url.searchParams.keys()].forEach(key => {
        if (key.startsWith('filter.')) {
          url.searchParams.delete(key);
        }
      });

      renderPage(url.toString()).then(html => {
        updateDOM(html);
        window.history.pushState({}, '', url);

        if (drawer?.closeDrawer) {
          drawer.closeDrawer();
          document.body.classList.remove("overflow-hidden", "open-filter-drawer");
        }
      });
    });
  }
}
customElements.define('facet-clear-component', FacetClearComponent);

/* ===============================
   SORTING
================================= */
class SortingFilterComponent extends HTMLElement {
  connectedCallback() {
    this.isInsideDrawer = !!this.closest('filters-drawer');

    this.querySelectorAll('.js-option').forEach(option => {
      option.addEventListener('click', () => {
        const value = option.dataset.value;

        const label = this.querySelector('.custom-select__btn span');
        if (label) label.textContent = option.textContent.trim();

        if (this.isInsideDrawer) {
          this.setAttribute('data-selected-sort', value);
          return;
        }

        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);

        renderPage(url.toString()).then(html => {
          updateDOM(html);
          window.history.pushState({}, '', url);
        });
      });
    });
  }

  getValue() {
    return this.getAttribute('data-selected-sort');
  }
}
customElements.define('sorting-filter-component', SortingFilterComponent);

/* ===============================
   PRICE FACET  
================================= */

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  fillSlider () {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    inputRangeWrappers.forEach(inputWrapper => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];

      const range = inputRangeTo.max - inputRangeTo.min;
      const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
      const toCurrent = inputRangeTo.value - inputRangeTo.min;
      const minRange = fromCurrent / range * 100;
      const maxRange = toCurrent / range * 100;

      inputWrapper.setAttribute(
        'style',
        `--range-min: ${minRange}%; --range-max: ${maxRange}%`
      );
    })
  }

  controlSlider () {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll('.field__range');
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom = inputNumberWrappers[index].querySelectorAll('.field__input')[0];
      const inputNumberTo = inputNumberWrappers[index].querySelectorAll('.field__input')[1];

      inputRangeFrom.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        }
        else {
          inputNumberFrom.value = from;
        }

        this.fillSlider();
      }

      if (Number(inputRangeTo.value) <= 0 ) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      inputRangeTo.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        }
        else {
          inputNumberTo.value = from;
          inputRangeTo.value = from;
        }

        if (Number(inputRangeTo.value) <= 0 ) {
          inputRangeTo.style.zIndex = 2;
        } else {
          inputRangeTo.style.zIndex = 0;
        }

        this.fillSlider();
      }
    })
  }

  controlInput() {
    const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
    const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

    inputNumberWrappers.forEach((inputWrapper, index) => {
      const inputsNumber = inputWrapper.querySelectorAll('.field__input');
      const inputNumberFrom = inputsNumber[0];
      const inputNumberTo = inputsNumber[1];
      const inputRangeFrom = inputRangeWrappers[index].querySelectorAll('.field__range')[0];
      const inputRangeTo = inputRangeWrappers[index].querySelectorAll('.field__range')[1];

      inputNumberFrom.oninput = () => {
        const from = parseInt(inputNumberFrom.value, 10);
        const to = parseInt(inputNumberTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          inputNumberFrom.value = to;
        } 
        else {
          inputRangeFrom.value = from;
        }

        this.fillSlider();
      }

      inputNumberTo.oninput = () => {
        const from = parseInt(inputNumberFrom.value, 10);
        const to = parseInt(inputNumberTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          inputNumberTo.value = to;
        }
        else {
          inputNumberTo.value = from;
        }

        this.fillSlider();
      }

    })
  }
}

customElements.define('price-range', PriceRange);



class PriceFacetComponent extends HTMLElement {
  connectedCallback() {
    this.isDrawer = !!this.closest('filters-drawer');

    this.addEventListener('input', () => {
      if (this.isDrawer) return;
      this.debounceApply();
    });

    this.addEventListener('change', () => {
      if (this.isDrawer) return;
      this.apply();
    });
  }

  apply() {
    const form = this.closest('form');
    const formData = new FormData(form);

    const url = new URL(window.location.href);

    // remove old price
    url.searchParams.delete('filter.v.price.gte');
    url.searchParams.delete('filter.v.price.lte');

    formData.forEach((value, key) => {
      if (
        (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') &&
        value !== ''
      ) {
        url.searchParams.set(key, value);
      }
    });

    renderPage(url.toString()).then(html => {
      updateDOM(html);
      window.history.pushState({}, '', url);
    });
  }

  debounceApply() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.apply(), 400);
  }
}
customElements.define('price-facet-component', PriceFacetComponent);

/* ===============================
   DRAWER APPLY
================================= */
class DrawerApplyFilters extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('.apply-filters-button');
      if (!btn) return;

      e.preventDefault();

      const drawer = document.querySelector('filters-drawer');
      const form = drawer?.querySelector('form');
      if (!form) return;

      const formData = new FormData(form);
      const url = new URL(window.location.href);

      // clear filters
      [...url.searchParams.keys()].forEach(key => {
        if (key.startsWith('filter.')) {
          url.searchParams.delete(key);
        }
      });

      // add new filters
      formData.forEach((value, key) => {
        if (value !== '') {
          url.searchParams.append(key, value);
        }
      });

      const sorting = drawer.querySelector('sorting-filter-component');
      const sortValue = sorting?.getValue();
      if (sortValue) {
        url.searchParams.set('sort_by', sortValue);
      }

      renderPage(url.toString()).then(html => {
        updateDOM(html);
        window.history.pushState({}, '', url);
      });

      if (drawer?.closeDrawer) {
        drawer.closeDrawer();
        document.body.classList.remove("overflow-hidden", "open-filter-drawer");
      }
    });
  }
}
customElements.define('drawer-apply-filters', DrawerApplyFilters);

/* ===============================
   BACK/FORWARD FIX
================================= */
window.addEventListener('popstate', () => {
  renderPage(window.location.href).then(updateDOM);
});